import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Result } from 'antd';
import { TextService } from "../../Services/TextService";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";

const NewUserCreatedWithProvider = () => {
  const GetText = TextService.GetText;
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  const newUser = searchParams.get("newUser");

  useEffect(() => {
    if (newUser === "true") {
      navigation("/" + getCurrentLanguage() + "/CompleteExternalRegistration");
    }
  }, []);

  return <div id="start">
    <Result
      status="success"
      title={GetText("NewUserCreatedWithProvider_Title")}
      subTitle={GetText("NewUserCreatedWithProvider_Description")}
    />
  </div>
};

export default NewUserCreatedWithProvider;